import { company } from "../config/company";

export const saveCompany = (data) => {
  return company.saveCompany(data).then(response => response)
};



